'use client';

import Image from 'next/image';
import Link from 'next/link';

import {
	ColorLeetcodeIcon,
	ColorLinkedinIcon,
	ColorTelegramIcon,
	ColorYoutubeIcon,
} from '@/shared';

import type { ITeamMember } from '../../types';

const iconMap = {
	telegram: ColorTelegramIcon,
	linkedin: ColorLinkedinIcon,
	youtube: ColorYoutubeIcon,
	leetcode: ColorLeetcodeIcon,
};

export const Team = ({ members }: { members: ITeamMember[] }) => {
	return (
		<div className="grid grid-cols-1 gap-2 lg:grid-cols-3 xl:gap-3 2xl:gap-6">
			{members.map((item, key) => (
				<dl
					key={key}
					className="flex flex-col gap-4 rounded-xl border border-[#DBDFE9] bg-white p-4 xl:gap-6 xl:rounded-3xl xl:p-6 2xl:gap-8 2xl:rounded-[40px] 2xl:p-8"
				>
					<dt className="flex flex-row gap-3 xl:gap-8">
						<Image
							src={item.image}
							alt={item.name}
							loading="lazy"
							width={140}
							height={140}
							className="aspect-square max-w-[100px] rounded-3xl object-cover xl:max-w-[140px]"
						/>
						<div className="flex-1">
							<div className="text-sm/[1.2] font-semibold text-[#252945] 2xl:text-2xl">
								{item.name}
							</div>
							<div className="mt-2 text-xs/[1.2] text-[#4B5675] xl:text-sm 2xl:text-base">
								{item.position}
							</div>
							<div className="mt-3 flex flex-row gap-3">
								{item.links.map((link, key) => {
									const IconComponent =
										iconMap[link.icon as keyof typeof iconMap];
									return IconComponent ? (
										<Link
											key={key}
											href={link.href}
											target="_blank"
											rel="noopener noreferrer"
										>
											<IconComponent className="size-6" />
										</Link>
									) : null;
								})}
							</div>
						</div>
					</dt>
					<dd className="space-y-3 text-xs/[1.2] text-[#4B5675] xl:text-sm/[1.4]">
						{item.content}
					</dd>
				</dl>
			))}
		</div>
	);
};
